import React from 'react';
import ConfirmDialog from 'chameleon/ui-stack/ui/modals/confirm-dialog';
import './ExitAssignmentModal.scss';

/**
 * Renders the modal for exiting the readiness check.
 * This is a confirmation modal for student.
 * */
export const DummyExitModal = ({ submitBtnText, onSubmit, onClose }) => (
  <ConfirmDialog
    title="Submit"
    onSuccess={onSubmit}
    onClose={onClose}
    content={{
      btnPrimary: submitBtnText,
    }}
  >
    <p>
      You have successfully completed the Secure Assignment Readiness Check!
      Click ‘Exit’ to close the browser.
    </p>
  </ConfirmDialog>
);

/**
 * Renders the modal for submitting the readiness check.
 * This is a submission modal for student, it does not submit to learnosity,
 * but "mocks" the modal.
 * */
export const DummySubmitModal = ({ onSubmit, onClose }) => (
  <ConfirmDialog
    size="tiny"
    title="Submit"
    onSuccess={onSubmit}
    onClose={onClose}
    content={{
      btnPrimary: 'Yes',
    }}
  >
    <p>Are you sure you want to submit your assessment?</p>
  </ConfirmDialog>
);
